import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CoverLetterProvider, useCoverLetterEditor } from '../../context/CoverLetterContext';
import CoverLetterCanvas from '../../components/cover-letter/CoverLetterCanvas';
import CoverLetterSidePanel from '../../components/cover-letter/CoverLetterSidePanel';

function EditorLayout() {
    const { id } = useParams<{ id: string }>();
    const { loadCoverLetter, currentVersion, canvasRef } = useCoverLetterEditor();

    useEffect(() => {
        if (id) {
            loadCoverLetter(id);
        }
    }, [id, loadCoverLetter]);

    if (!currentVersion) {
        return (
            <div className="flex h-screen items-center justify-center bg-[#0c0e14] text-white">
                <div className="flex flex-col items-center gap-4">
                    <div className="w-8 h-8 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
                    <p className="text-gray-400">Loading cover letter...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex h-screen bg-[#0c0e14] overflow-hidden relative">
            {/* Top Left Navigation */}
            <div className="absolute top-4 left-4 z-50">
                <button
                    onClick={() => window.location.href = '/dashboard/resumes'} // Or a specific Cover Letters dashboard if exists
                    className="flex items-center gap-2 px-4 py-2 bg-black/50 hover:bg-white/10 text-gray-400 hover:text-white rounded-lg backdrop-blur-sm transition-all border border-white/5 hover:border-white/10"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                    </svg>
                    <span className="font-medium text-sm">Back</span>
                </button>
            </div>

            {/* Main Canvas Area */}
            <div className="flex-1 overflow-y-auto bg-[#1a1c23] p-8 flex justify-center">
                <div className="w-full max-w-[850px]">
                    <CoverLetterCanvas ref={canvasRef} />
                </div>
            </div>

            {/* Side Panel */}
            <div className="w-[400px] border-l border-white/5 bg-[#0c0e14] flex flex-col">
                <CoverLetterSidePanel />
            </div>
        </div>
    );
}

export default function CoverLetterEditorPage() {
    return (
        <CoverLetterProvider>
            <EditorLayout />
        </CoverLetterProvider>
    );
}
